export default __webpack_public_path__ + "static/media/icon-product-nooio-blog.f5b7a1b9.svg";